import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Chat from './pages/Chat';
import Admin from './pages/Admin';
import Projects from './pages/Projects';
import Notifications from './pages/Notifications';
import QueryHistory from './pages/QueryHistory';
import Login from './pages/Login';
import { AuthProvider } from './context/AuthContext';
import { ChatProvider } from './context/ChatContext';
import { NightlyJobProvider } from './context/NightlyJobContext';
import { ProtectedRoute, AdminRoute, ProjectsRoute } from './components/ProtectedRoute';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        {/* ChatProvider sits above <Routes> (Dev, 2026-07-03) so chat state —
            messages, the in-flight "loading" flag, which conversation is
            open — survives navigating to /admin or /projects and back.
            Only <Routes>'s children unmount on navigation; this Provider
            (and everything it holds) doesn't. */}
        <ChatProvider>
          <NightlyJobProvider>
            <Routes>
              <Route path="/" element={<Navigate to="/chat" replace />} />
              <Route path="/login" element={<Login />} />
              <Route path="/chat" element={<ProtectedRoute><Chat /></ProtectedRoute>} />
              <Route path="/admin" element={<AdminRoute><Admin /></AdminRoute>} />
              <Route path="/projects" element={<ProjectsRoute><Projects /></ProjectsRoute>} />
              <Route path="/notifications" element={<AdminRoute><Notifications /></AdminRoute>} />
              <Route path="/query-history" element={<AdminRoute><QueryHistory /></AdminRoute>} />
            </Routes>
          </NightlyJobProvider>
        </ChatProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
